import { useEventSource } from 'remix-utils/sse/react'
import {
	type EventPayloadMap,
	type EventType,
} from '#app/services/emitter.types.ts'

export function useJsonEventSource<T extends EventType>(event: T) {
	let data = useEventSource('/sse/events', { event })
	if (!data) return null
	return JSON.parse(data) as EventPayloadMap[T]
}
